import { putMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const UPDATE_QUESTIONNAIRENAIRE = 'UPDATE_QUESTIONNAIRE';
export const UPDATE_QUESTIONNAIRE_SUCCESS = 'UPDATE_QUESTIONNAIRE_SUCCESS';
export const UPDATE_QUESTIONNAIRE_FAILURE = 'UPDATE_QUESTIONNAIRE_FAILURE';

// Action Creators
export const updateQuestionnaireRequest = () => ({
  type: UPDATE_QUESTIONNAIRENAIRE,
});

export const updateQuestionnaireSuccess = (users) => ({
  type: UPDATE_QUESTIONNAIRE_SUCCESS,
  payload: users,
});

export const updateQuestionnaireFailure = (error) => ({
  type: UPDATE_QUESTIONNAIRE_FAILURE,
  payload: error,
});

// Thunk Function
export const updateQuestionnaire = (external, body, id) => {
  return async (dispatch) => {
    dispatch(updateQuestionnaireRequest());
    try {
      const response = await putMethodWithToken(
        url.updateQuestionnaire + id + '/',
        body
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(updateQuestionnaireSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(updateQuestionnaireFailure('error?.message'));
      }
    } catch (error) {
      dispatch(updateQuestionnaireFailure(error?.message));
    }
  };
};
